class Validation {
  hasProperty(object: unknown, property: string): boolean {
    return Object.prototype.hasOwnProperty.call(object, property);
  }
}

export default new Validation();
